import domain from './domain';

export const resetClientBrandProfiles = domain.createEvent('resetClientBrandProfiles');
